import React from 'react';
import projectServices from '../data/projectServices';
import '../pages-styles/project-consultancy.css';

function AppDevelopment() {
  const svc = projectServices.find(s => s.slug === 'app-development');
  if (!svc) return <div className="service-detail"><h2>Service not found</h2></div>;

  return (
    <div className="service-detail">
      <section className="page-intro">
        <h1>{svc.title}</h1>
        <p className="tagline">{svc.tagline}</p>
      </section>

      <section className="service-main">
        <div className="service-left">
          <div className="service-icon-large">{svc.icon}</div>
          <p className="service-summary">{svc.professional}</p>
        </div>
        <div className="service-right">
          <h3>What we offer</h3>
          <ul>
            {svc.details.map((d, i) => <li key={i}>{d}</li>)}
          </ul>
          <div className="service-cta">
            <a className="btn primary" href={`/works/${svc.slug}`}>View Works</a>
            <a className="btn secondary" href="/contact">Contact Us</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AppDevelopment;
